export const LOGIN_USER = "LOGIN_USER"
export const LOGOUT_USER = "LOGOUT_USER"

export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const SAVE_ATTR = 'SAVE_ATTR'
export const INSERT_USER = 'INSERT_USER'
export const DELETE_USER = 'DELETE_USER'